<template>
  <AllegroJsonForm
    title="Allegro - Dodaj odbiorcę"
    crumbLabel="Dodaj odbiorcę"
    :settingsCrumb="true"
    submitAction="createAllegroCodReceiver"
    submitGetter="getAllegroCodReceiverCreateData"
    backRoute="/allegro/accounts"
    accountPkParam="pk"
    :modelPermission="modelPermission"
    :fields="fields"
  />
</template>

<script>
import AllegroJsonForm from "./AllegroJsonForm.vue";
import { allegroCodReceiverPermissionsConst } from "../../constants/allegroConstants";

export default {
  name: "AllegroCodReceiverCreate",
  components: { AllegroJsonForm },
  data() {
    return {
      modelPermission: allegroCodReceiverPermissionsConst.add,
      fields: [
        { key: "name", label: "Nazwa", required: true },
        { key: "iban", label: "Nr konta (IBAN)", required: true },
      ],
    };
  },
};
</script>
